import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, DialogContent, ClickAwayListener, Paper } from '@mui/material';
import styles from './ReusableComponents.module.css';

function WideModal(props) {
  const {
    children,
    open = false,
    onClickAway = null,
    onClose,
    onRendered = () => {},
  } = props;

  useEffect(() => {
    if (open) {
      onRendered();
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <DialogContent className={styles.modalContainer}>
        <ClickAwayListener onClickAway={onClickAway || onClose}>
          <div className={styles.modalInner}>
            <Paper className={styles.wideModal}>{children}</Paper>
          </div>
        </ClickAwayListener>
      </DialogContent>
    </Modal>
  );
}

WideModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onClose: PropTypes.func.isRequired,
  onClickAway: PropTypes.func,
  onRendered: PropTypes.func,
  open: PropTypes.bool,
};

export default WideModal;
